<template>
  <v-card flat color="transparent" class="py-1">
    <v-row>
      <v-col class="text-h5 font-weight-bold">
        Assessment Summary
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        {{ profile.companyName }} has enabled the employee rating and
        compensation portion of the review area for you. This section allows you
        to provide {{ this.annualreview.user.firstName }} with a rating,
        suggested pay and suggested bonus. Your answers will be visible to
        {{ this.annualreview.user.firstName }} and after sign off they will be
        submitted to HR.
      </v-col>
    </v-row>
    <v-divider class="mb-4 mt-2"></v-divider>
    <v-row>
      <v-col cols="12" md="7">
        <v-card height="100%">
          <v-card-text>
            <v-row>
              <v-col cols="auto">
                <user-avatar
                  :size="180"
                  :user="annualreview.user"
                  borderColor="performance"
                  color="performance"
                  cssClass="halo text-h3"
                  textColor="white"
                ></user-avatar>
              </v-col>
              <v-col>
                <v-row>
                  <v-col
                    cols="12"
                    class="text-h5 font-weight-bold primarytext--text"
                  >
                    Compensation Changes
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      v-model="annualreview.suggestedPayIncrease"
                      type="number"
                      label="Suggested Pay Increase"
                      @change="save"
                      :disabled="
                        annualreview.managerQuestionsCompleteDate != null
                      "
                    >
                      <template v-slot:prepend-inner>$</template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      outlined
                      v-model="annualreview.isPayIncreaseHourly"
                      :items="hourlyItems"
                      item-text="name"
                      item-value="id"
                      label="Pay Increase Type"
                      @change="save"
                      :disabled="
                        annualreview.managerQuestionsCompleteDate != null
                      "
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      v-model="annualreview.suggestedBonus"
                      type="number"
                      label="Suggested Bonus"
                      @change="save"
                      :disabled="
                        annualreview.managerQuestionsCompleteDate != null
                      "
                    >
                      <template v-slot:prepend-inner>$</template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="5">
        <v-card height="100%">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col
                    cols="12"
                    class="text-h5 font-weight-bold primarytext--text"
                  >
                    <v-icon class="mr-2" color="primarytext">grade</v-icon
                    >Employee Rating
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      label="Employee Rating"
                      v-model="annualreview.userRating"
                      outlined
                      :items="annual_review_ratings"
                      item-text="title"
                      item-value="id"
                      @change="save"
                      :disabled="
                        annualreview.managerQuestionsCompleteDate != null
                      "
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewAssessmentSection",
  data: () => ({
    saving: false,
    hourlyItems: [
      { id: false, name: "Salary" },
      { id: true, name: "Hourly" }
    ]
  }),
  computed: {
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      profile: "profile/profile",
      annual_review_ratings: "settings/annual_review_ratings"
    })
  },
  mounted() {
    this.$store.dispatch("settings/getAnnualReviewRatings");
  },
  methods: {
    save() {
      this.saving = true;
      this.$store
        .dispatch("annualreview/saveRatingAndPay", this.annualreview)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Rating and Suggestions saved");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while saving your rating."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__prepend-inner {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
